import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icon paths (Leaflet quirk with bundlers)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const amberIcon = L.divIcon({
  className: "ocmap-marker",
  html: `<div style="
    width:28px;height:28px;border-radius:50%;
    background:#d97706;border:3px solid #020617;
    box-shadow:0 0 0 2px #d97706;"></div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 14],
});

export default function MapView({ markers = [], height = 360, zoom = 12, center }) {
  const validMarkers = markers.filter((m) => m.lat != null && m.lng != null);
  const fallback = validMarkers[0] || { lat: 26.85, lng: 80.94 };
  const c = center || { lat: fallback.lat, lng: fallback.lng };

  return (
    <div style={{ height }} className="border border-white/10 overflow-hidden" data-testid="map-view">
      <MapContainer
        center={[c.lat, c.lng]}
        zoom={zoom}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%", background: "#020617" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        />
        {validMarkers.map((m, i) => (
          <Marker key={i} position={[m.lat, m.lng]} icon={amberIcon}>
            <Popup>
              <div style={{ color: "#020617", fontFamily: "Outfit, sans-serif" }}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>{m.name}</div>
                <div style={{ fontSize: 12, color: "#475569" }}>{m.locality}, {m.city}</div>
                {m.price && <div style={{ marginTop: 4, color: "#d97706", fontWeight: 600 }}>{m.price}</div>}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
